import {Component, HostListener, Input, ViewEncapsulation} from '@angular/core';
import {NavigationComponentService} from '@app/services/navigation-component.service';
import {NgbDropdown, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {DcpSupportFormService} from '@app/shared/support-form/dcp-support-form.service';

const SUPPORT_REQUEST_CHECK: string = 'supportrequest';

@Component({
  selector: 'dcp-help-icon-links',
  templateUrl: './help-icon-links.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HelpIconLinksComponent {
  @Input() helpIconLinks: any;
  @Input() dropdown: NgbDropdown;
  supportModal: NgbModalRef;
  supportFormCloseEventData: string = 'SAP_REQUEST_FORM:CLOSE';

  constructor(
    public navigationComponentService: NavigationComponentService,
    public dcpSupportFormService: DcpSupportFormService,
    private modalService: NgbModal,
  ) {
  }

  isSupportRequestUrl(url: string): boolean {
    return url?.includes(SUPPORT_REQUEST_CHECK);
  }

  closeDropdown(): void {
    if (this.dropdown) {
      this.dropdown.close();
    }
  }

  handleSupportFormCloseEvent(event: MessageEvent): void {
    if (event.data && event.data === this.supportFormCloseEventData) {
      this.closeModal();
    }
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent) {
    if (event.source && event.source !== window && this.supportModal) {
      this.handleSupportFormCloseEvent(event);
    }
  }

  closeModal(): void {
    if (this.supportModal) {
      this.supportModal.dismiss();
    }
  }

  openSupportRequestModal(content: any): void {
    this.closeDropdown();
    this.supportModal = this.modalService.open(content, {
      keyboard: true,
      windowClass: 'help-support-request-modal'
    });
  }
}
